import React from 'react';

interface TextClassificationIconV2Props {
  style?: React.CSSProperties;
}

const TextClassificationIconV2: React.FC<TextClassificationIconV2Props> = ({ style }) => {
  return <img style={style} src="/static/images/text-classification.png" />;
};

export default TextClassificationIconV2;
